import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const categories = [
  { img: '/images/categories/SUV.png', title: 'SUV', value: 'SUV' },
  { img: '/images/categories/Sedan.png', title: 'Sedan', value: 'SEDAN' },
  { img: '/images/categories/Hatchback.png', title: 'Hatchback', value: 'HATCHBACK' },
  { img: '/images/categories/Coup.png', title: 'Coupe', value: 'COUPE' },
  { img: '/images/categories/Pickup.png', title: 'Pickup', value: 'PICKUP' },
  { img: '/images/categories/Cabriolet.png', title: 'Convertible', value: 'CONVERTIBLE' },
];

const CategorySection: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleCategoryClick = (categoryVal: string) => {
        navigate(`/mysearch?bodyType=${categoryVal}`);
    };

  return (
    <section className="hp-section hp-bg-alt">
      <div className="hp-container">
        <div className="hp-section-header">
          <h2>{t('home.category_title')}</h2>
          <p>{t('home.category_subtitle')}</p>
        </div>
        <div className="row g-4">
          {categories.map((cat, index) => (
            <div key={index} className="col-6 col-md-4 col-lg-2">
              <div 
                className="hp-category-card" 
                onClick={() => handleCategoryClick(cat.value)}
              >
                <div className="hp-category-img-wrapper">
                    <img src={cat.img} alt={cat.title} className="hp-category-image" />
                </div>
                <h5 className="hp-category-title">{cat.title}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
